import React from 'react';
import {Footer} from '../../_common/components/Footer/Footer';

export const LawFooter = ({value, totalAmount}: {value: number; totalAmount: number}) => {

  return <Footer count={value} totalAmount={totalAmount}/>;
};
